import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import SvgMaterialIcons from './SvgMaterialIcons';
import ClientProvider from './client';
export default createDemo(import.meta.url, SvgMaterialIcons, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/icons/demos/svg-material/SvgMaterialIcons.tsx",
    "fileName": "SvgMaterialIcons.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Box from '@mui/material/Box';\nimport Grid from '@mui/material/Grid';\nimport Typography from '@mui/material/Typography';\nimport DeleteIcon from '@mui/icons-material/Delete';\nimport DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';\nimport DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';\nimport DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';\nimport DeleteSharpIcon from '@mui/icons-material/DeleteSharp';\nimport DeleteForeverIcon from '@mui/icons-material/DeleteForever';\nimport DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';\nimport DeleteForeverRoundedIcon from '@mui/icons-material/DeleteForeverRounded';\nimport DeleteForeverTwoToneIcon from '@mui/icons-material/DeleteForeverTwoTone';\nimport DeleteForeverSharpIcon from '@mui/icons-material/DeleteForeverSharp';\nimport ThreeDRotationIcon from '@mui/icons-material/ThreeDRotation';\nimport FourKIcon from '@mui/icons-material/FourK';\nimport ThreeSixtyIcon from '@mui/icons-material/ThreeSixty';\n\nexport default function SvgMaterialIcons() {\n  return (\n    <Box sx={{ flexGrow: 1 }}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 3,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Grid container sx={{ color: 'text.primary' }}>\n        <Grid size={4}>\n          <Typography>Filled</Typography>\n        </Grid>\n        <Grid size={8}>\n          <DeleteIcon />\n          <DeleteForeverIcon />\n        </Grid>\n        <Grid size={4}>\n          <Typography>Outlined</Typography>\n        </Grid>\n        <Grid size={8}>\n          <DeleteOutlinedIcon />\n          <DeleteForeverOutlinedIcon />\n        </Grid>\n        <Grid size={4}>\n          <Typography>Rounded</Typography>\n        </Grid>\n        <Grid size={8}>\n          <DeleteRoundedIcon />\n          <DeleteForeverRoundedIcon />\n        </Grid>\n        <Grid size={4}>\n          <Typography>Two Tone</Typography>\n        </Grid>\n        <Grid size={8}>\n          <DeleteTwoToneIcon />\n          <DeleteForeverTwoToneIcon />\n        </Grid>\n        <Grid size={4}>\n          <Typography>Sharp</Typography>\n        </Grid>\n        <Grid size={8}>\n          <DeleteSharpIcon />\n          <DeleteForeverSharpIcon />\n        </Grid>\n        <Grid size={4}>\n          <Typography>Edge-cases</Typography>\n        </Grid>\n        <Grid size={8}>\n          <ThreeDRotationIcon />\n          <FourKIcon />\n          <ThreeSixtyIcon />\n        </Grid>\n      </Grid>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Box>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 68,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Box from '@mui/material/Box';\nimport Grid from '@mui/material/Grid';\nimport Typography from '@mui/material/Typography';\nimport DeleteIcon from '@mui/icons-material/Delete';\nimport DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';\nimport DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';\nimport DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';\nimport DeleteSharpIcon from '@mui/icons-material/DeleteSharp';\nimport DeleteForeverIcon from '@mui/icons-material/DeleteForever';\nimport DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';\nimport DeleteForeverRoundedIcon from '@mui/icons-material/DeleteForeverRounded';\nimport DeleteForeverTwoToneIcon from '@mui/icons-material/DeleteForeverTwoTone';\nimport DeleteForeverSharpIcon from '@mui/icons-material/DeleteForeverSharp';\nimport ThreeDRotationIcon from '@mui/icons-material/ThreeDRotation';\nimport FourKIcon from '@mui/icons-material/FourK';\nimport ThreeSixtyIcon from '@mui/icons-material/ThreeSixty';\n\nexport default function SvgMaterialIcons() {\n  return (\n    <Box sx={{ flexGrow: 1 }}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 3
        },
        "      <Grid container sx={{ color: 'text.primary' }}>\n        <Grid size={4}>\n          <Typography>Filled</Typography>\n        </Grid>\n        <Grid size={8}>\n          <DeleteIcon />\n          <DeleteForeverIcon />\n        </Grid>\n        <Grid size={4}>\n          <Typography>Outlined</Typography>\n        </Grid>\n        <Grid size={8}>\n          <DeleteOutlinedIcon />\n          <DeleteForeverOutlinedIcon />\n        </Grid>\n        <Grid size={4}>\n          <Typography>Rounded</Typography>\n        </Grid>\n        <Grid size={8}>\n          <DeleteRoundedIcon />\n          <DeleteForeverRoundedIcon />\n        </Grid>\n        <Grid size={4}>\n          <Typography>Two Tone</Typography>\n        </Grid>\n        <Grid size={8}>\n          <DeleteTwoToneIcon />\n          <DeleteForeverTwoToneIcon />\n        </Grid>\n        <Grid size={4}>\n          <Typography>Sharp</Typography>\n        </Grid>\n        <Grid size={8}>\n          <DeleteSharpIcon />\n          <DeleteForeverSharpIcon />\n        </Grid>\n        <Grid size={4}>\n          <Typography>Edge-cases</Typography>\n        </Grid>\n        <Grid size={8}>\n          <ThreeDRotationIcon />\n          <FourKIcon />\n          <ThreeSixtyIcon />\n        </Grid>\n      </Grid>\n"
      ],
      [
        "span",
        "frame",
        "    </Box>\n  );\n}\n"
      ]
    ],
    "totalLines": 68,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/Box",
      "@mui/material/Grid",
      "@mui/material/Typography",
      "@mui/icons-material/Delete",
      "@mui/icons-material/DeleteOutlined",
      "@mui/icons-material/DeleteRounded",
      "@mui/icons-material/DeleteTwoTone",
      "@mui/icons-material/DeleteSharp",
      "@mui/icons-material/DeleteForever",
      "@mui/icons-material/DeleteForeverOutlined",
      "@mui/icons-material/DeleteForeverRounded",
      "@mui/icons-material/DeleteForeverTwoTone",
      "@mui/icons-material/DeleteForeverSharp",
      "@mui/icons-material/ThreeDRotation",
      "@mui/icons-material/FourK",
      "@mui/icons-material/ThreeSixty"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
